import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { cn } from '../../lib/cn';
import type { Etichetta } from '../../lib/eventi/tipi';

/** Radix non accetta un valore vuoto: "nessuna" ha un valore suo. */
const NESSUNA = '__nessuna__';

type Props = {
  id: string;
  etichetta: string;
  spiegazione: string;
  valore: string | null;
  opzioni: Etichetta[];
  onCambia: (id: string | null) => void;
  /** 'riga': testo a sinistra e menu a destra, per gli elenchi di regole automatiche. */
  disposizione?: 'colonna' | 'riga';
};

/** Menu per scegliere una lista o un'etichetta di Mailing, con una riga che spiega a cosa serve. */
export function SceltaEtichetta({ id, etichetta, spiegazione, valore, opzioni, onCambia, disposizione = 'colonna' }: Props) {
  const esiste = !valore || opzioni.some((o) => o.id === valore);
  const inRiga = disposizione === 'riga';
  return (
    <div className={cn(inRiga && 'grid gap-2 md:grid-cols-[minmax(0,1fr)_17rem] md:items-center md:gap-6')}>
      <div className={cn(inRiga && 'order-1')}>
        <Label htmlFor={id} className={cn(inRiga ? 'text-sm font-medium text-gray-900' : 'text-xs')}>
          {etichetta}
        </Label>
        {inRiga && <p className="mt-0.5 text-[11px] leading-relaxed text-neutral-500">{spiegazione}</p>}
      </div>
      <Select value={valore ?? NESSUNA} onValueChange={(v) => onCambia(v === NESSUNA ? null : v)}>
        <SelectTrigger id={id} className={cn(inRiga ? 'order-2' : 'mt-1')}>
          <SelectValue placeholder="Scegli…" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={NESSUNA}>— Nessuna —</SelectItem>
          {!esiste && valore && <SelectItem value={valore}>(eliminata)</SelectItem>}
          {opzioni.map((o) => (
            <SelectItem key={o.id} value={o.id}>
              {o.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {!inRiga && <p className="text-[11px] text-neutral-500 mt-1 leading-relaxed">{spiegazione}</p>}
    </div>
  );
}
